<template>
    <div class="fs-form">
        <fsForm @submit="signup" name="Registrierung" :formData="formData" />
    </div>
</template>

<script>
import fullscreenForm from "@/components/fullscreenForm"
import Parse from 'parse'
import {toast} from '@/utils/interactions'

export default {
    components: {
        fsForm: fullscreenForm
    },
    methods: {
        signup() {
            var form = this.formData;
            var data = {
                name: form.name.value,
                mail: form.email.value,
                phone: form.phone.value,
                token: form.token.value,
                description: form.description.value,
                address: form.address.value,
                password: form.password.value,
            };

            let loader = this.$loading.show();
            Parse.Cloud.run('register', data).then((result) => {
                
                if (result) {
                    Parse.User.logIn(data.mail, data.password).then(() => {
                        this.$router.push('/announcements');
                    }).catch(() => {
                        // TODO: error handling
                    });
                } else {

                    toast("Bei der Anmeldung gab es ein Problem. Bitte wende dich an den Administrator.")
                    // TODO: error handling
                }
            }).catch(() => {
                // TODO: error handling
                toast("Bei der Anmeldung gab es ein Problem. Bitte wende dich an den Administrator.")
            }).always(() => {
                loader.hide();
            });
        },
        goto_login() {
            this.$router.push('/login');
        },
        register() {
            this.$router.push('/announcements');
        },
    },
    mounted() {
        if (this.$route.query.token) {
            this.formData.token.value = this.$route.query.token;
        }
    },
    data() {
        return {
            code: null,
            formData: {
                token: {
                    type: "text",
                    label: "Der Zugangscode",
                    placeholder: "AY9184DH",
                    required: true,
                    class: 'registration-token',
                },
                /*
                type: {
                    type: "radio",
                    label: "Als was möchtest du dich registrieren?",
                    options: {
                        "applicant": "Bewerber",
                        "employer": "Steuerberater",
                        
                    },
                    value: "",
                    required: true
                },
                */
                name: {
                    type: "text",
                    //label: "Vor- und Zuname eingeben",
                    label: 'Name eingeben',
                    placeholder: "Julia Beyer",
                    required: true
                },
                email: {
                    type: "email",
                    label: "E-Mail eingeben",
                    placeholder: "julia.beyer@example.com",
                    required: true
                },
                phone: {
                    type: "text",
                    label: "Telefonnummer eingeben",
                    placeholder: "0381 123 456 78",
                    required: true
                },
                address: {
                    type: "address",
                    label: "Adresse eingeben",
                    placeholder: "Straße Hausnummer, PLZ Stadt",
                    required: true
                },
                description: {
                    type: "textarea",
                    label: "Beschreibe dich in ein paar Worten.",
                    placeholder: "",
                    required: true
                },
                password: {
                    type: "password",
                    label: "Lege ein sicheres Passwort fest",
                    descr: "Ein sicheres Passwort besitzt Groß- und Kleinbuchstaben, Sonderzeichen und ist mindestens 8 Zeichen lang.",
                    placeholder: "Uer%gho442ar",
                    required: true,
                    validation(value) {
                        return value.length > 5;
                    }
                },
                disclaimer: {
                    type: "checkbox",
                    label: "Einverständniserklärung",
                    placeholder: "",
                    required: true,
                    options: {
                        "true": "Ich gebe die Zustimmung, dass meine Daten an die Steuerberaterkammer MV übertragen werden."
                    }
                },
            }
        }
    },
}
</script>

<style lang="scss">
    .fs-form {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: $primary-color;

        .registration-token input {
            text-transform: uppercase;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/registration.vue